import { SxProps, Theme } from '@mui/material/styles';

// Sx Styles
export const cardContainerSx: SxProps<Theme> = {
  paddingY: { xs: '16px', sm: '24px' },
  paddingX: '0'
};

export const contentWrapperSx: SxProps<Theme> = {
  paddingX: { xs: '16px', sm: '20px', md: '24px' },
  // marginBottom: { xs: '12px', sm: '16px', md: '16px' }
};

export const headerContainerSx: SxProps<Theme> = {
  marginBottom: { xs: '16px', sm: '12px', md: '16px' },
  display: 'flex',
  flexDirection: { xs: 'column', sm: 'row' },
  justifyContent: 'space-between',
  alignItems: { xs: 'flex-start', sm: 'center' },
  gap: { xs: '12px', sm: '16px', md: '20px' },
  flexWrap: { xs: 'nowrap', md: 'wrap' }
};

export const titleSx: SxProps<Theme> = {
  fontFamily: 'Inter',
  fontWeight: 600,
  fontSize: { xs: '20px', sm: '22px', md: '24px' },
  lineHeight: { xs: '28px', sm: '30px', md: '32px' },
  color: 'var(--color-primary)',
  flexShrink: 0
};

export const headerActionsSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: { xs: 'column', sm: 'row' },
  alignItems: { xs: 'flex-start', sm: 'center' },
  gap: { xs: '8px', sm: '12px' },
  width: { xs: '100%', sm: 'auto' }
};

export const selectedCountSx: SxProps<Theme> = {
  fontFamily: 'Inter',
  fontWeight: 400,
  fontSize: { xs: '13px', sm: '13px', md: '14px' },
  lineHeight: { xs: '18px', sm: '18px', md: '20px' },
  color: 'var(--color-primary)',
  minWidth: 'max-content',
  whiteSpace: 'nowrap'
};

export const totalPriceSx: SxProps<Theme> = {
  fontFamily: 'Inter',
  fontWeight: 600,
  fontSize: { xs: '14px', sm: '15px', md: '16px' },
  lineHeight: { xs: '20px', sm: '22px', md: '24px' },
  color: 'var(--color-primary)',
  minWidth: 'max-content',
  whiteSpace: 'nowrap'
};

export const removeAllButtonSx: SxProps<Theme> = {
  fontFamily: 'Inter',
  fontWeight: 600,
  fontSize: { xs: '13px', sm: '14px', md: '14px' },
  lineHeight: { xs: '18px', sm: '20px', md: '20px' },
  color: 'var(--color-primary)',
  paddingX: { xs: '12px', sm: '16px', md: '18px' },
  paddingY: { xs: '8px', sm: '10px', md: '10px' },
  width: { xs: '100%', sm: 'auto' },
  minWidth: { xs: '100%', sm: 'max-content' },
  whiteSpace: 'nowrap'
};

export const descriptionSx: SxProps<Theme> = {
  fontFamily: 'Inter',
  fontWeight: 400,
  fontSize: { xs: '14px', sm: '15px', md: '16px' },
  lineHeight: { xs: '20px', sm: '22px', md: '24px' },
  color: 'var(--color-text-purple)',
  wordBreak: 'break-word'
};


export const businessNameTypographySx: SxProps<Theme> = {
  fontFamily: 'Inter',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: 'var(--line-height-18)',
  color: 'var(--color-purple-strong)'
};

export const notesTypographySx: SxProps<Theme> = {
  fontFamily: 'Inter',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: 'var(--line-height-18)',
  letterSpacing: '0%',
  color: 'var(--color-text-near-black)'
};

export const notesIconsContainerSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px'
};

export const tableCellTypographySx: SxProps<Theme> = {
  fontFamily: 'Inter',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: 'var(--line-height-18)',
  color: 'var(--color-text-near-black)'
};

// Ordered Data Table Styles
export const orderedItemTitleSx: SxProps<Theme> = {
  fontFamily: 'Inter',
  fontWeight: 400,
  fontSize: { xs: '11px', sm: '12px' },
  lineHeight: { xs: '16px', sm: '18px' },
  color: 'var(--color-primary)'
};

export const orderedPriceContainerSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: { xs: '6px', sm: '8px' }
};

export const orderedPriceSx: SxProps<Theme> = {
  fontFamily: 'Inter',
  fontWeight: 400,
  fontSize: { xs: '11px', sm: '12px' },
  lineHeight: { xs: '16px', sm: '18px' },
  color: 'var(--color-primary)'
};

export const closeIconSx: SxProps<Theme> = {
  fontSize: { xs: '18px', sm: '20px' },
  color: 'var(--color-primary)',
  cursor: 'pointer'
};

// Layout Styles
export const mainContainerSx: SxProps<Theme> = {
  width: '100%',
  marginTop: 0,
  marginBottom: { xs: '16px', sm: '24px' },
  boxSizing: 'border-box'
};

export const flexContainerSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: { xs: 'column', md: 'row' },
  gap: { xs: '16px', md: '20px', lg: '24px' },
  maxWidth: { xs: '100%', md: '1400px' },
  margin: '0 auto',
  width: '100%',
  // paddingX: { xs: '16px'},
  marginBottom: { xs: '16px', sm: '24px' },
  boxSizing: 'border-box'
};

export const leftSideContainerSx: SxProps<Theme> = {
  flex: { xs: '1 1 100%', md: '1 1 auto' },
  display: 'flex',
  flexDirection: 'column',
  gap: { xs: '16px', sm: '24px' },
  minWidth: 0,
  // overflow: 'hidden'
};

export const cardContainerWrapperSx: SxProps<Theme> = {
  marginBottom: { xs: '16px', sm: '24px' }
};

export const cardContainerWithCommonSx: SxProps<Theme> = {
  width: '100%',
  borderRadius: { xs: '8px', sm: '12px' },
  boxShadow: '0px 1px 8px 0px var(--color-shadow-card)',
  padding: '24px',
  paddingY: { xs: '16px', sm: '24px' },
  paddingX: '0',
  // marginBottom: { xs: '16px', sm: '24px' }
};

// Campaign Order Styles
export const campaignOrderContainerSx: SxProps<Theme> = {
  width: '100%',
  backgroundColor: 'var(--color-white)',
  borderRadius: { xs: '8px', sm: '12px' },
  border: '1px solid rgba(0, 0, 0, 0.1)',
  boxShadow: '0px 1px 8px 0px var(--color-shadow-card)',
  paddingTop: { xs: '16px', sm: '24px' },
  paddingBottom: { xs: '16px', sm: '24px' },
  paddingLeft: { xs: '0px', sm: '0px' },
  paddingRight: { xs: '0px', sm: '0px' },
  height: 'fit-content',
  // position: { lg: 'sticky' },
  // top: { lg: '70px' },
  // overflow: { xs: 'hidden', sm: 'visible' }
};

export const campaignOrderTitleSx: SxProps<Theme> = {
  fontFamily: 'Inter',
  fontWeight: 600,
  fontSize: { xs: '18px', sm: '24px' },
  lineHeight: { xs: '26px', sm: '32px' },
  color: 'var(--color-primary)',
  paddingLeft: { xs: '16px', sm: '24px' },
  paddingRight: { xs: '16px', sm: '24px' },
  marginBottom: '24px'
};

export const totalContainerSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: { xs: '12px 16px', sm: '12px 24px' },
  marginTop: { xs: '8px', sm: '0px' }
};

export const totalLabelSx: SxProps<Theme> = {
  fontFamily: 'Inter',
  fontWeight: 700,
  fontSize: { xs: '16px', sm: '20px' },
  lineHeight: { xs: '24px', sm: '30px' },
  color: 'var(--color-text-secondary)'
};

export const totalPriceValueSx: SxProps<Theme> = {
  fontFamily: 'Inter',
  fontWeight: 700,
  fontSize: { xs: '22px', sm: '20px' },
  lineHeight: { xs: '30px', sm: '30px' },
  color: 'var(--color-primary)'
};

export const buttonsContainerSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: { xs: '10px', sm: '16px' },
  padding: { xs: '12px 16px', sm: '12px 24px' },
  marginTop: { xs: '8px', sm: '0px' }
};

export const oneTimePaymentButtonSx: SxProps<Theme> = {
  backgroundColor: 'var(--color-primary)',
  color: 'var(--color-white)',
  fontFamily: 'Inter',
  fontWeight: 600,
  fontSize: { xs: '14px', sm: '16px' },
  lineHeight: { xs: '20px', sm: '24px' },
  padding: { xs: '10px 20px', sm: '12px 24px' },
  borderRadius: '6px',
  textTransform: 'none',
  width: '100%',
  '&:hover': {
    backgroundColor: 'var(--color-primary-ultra)'
  }
};

export const saveForLaterButtonSx: SxProps<Theme> = {
  borderColor: 'var(--color-primary)',
  color: 'var(--color-primary)',
  fontFamily: 'Inter',
  fontWeight: 600,
  fontSize: { xs: '14px', sm: '16px' },
  lineHeight: { xs: '20px', sm: '24px' },
  padding: { xs: '10px 20px', sm: '12px 24px' },
  borderRadius: '6px',
  textTransform: 'none',
  width: '100%',
  '&:hover': {
    borderColor: 'var(--color-primary-ultra)',
    backgroundColor: 'rgba(18, 2, 66, 0.04)'
  }
};

// Duplicate Citations Styles
export const duplicateCardSx: React.CSSProperties = {
  position: 'relative'
};

export const duplicateContentWrapperSx: SxProps<Theme> = {
  paddingX: '24px'
};

export const warningBoxSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: { xs: 'flex-start', sm: 'center' },
  gap: { xs: '8px', sm: '8px' },
  backgroundColor: 'var(--color-warning-pale)',
  padding: { xs: '10px 12px', sm: '12px 20px' },
  border: '1px solid var(--color-warning-orange)',
  borderRadius: { xs: '6px', sm: '8px' },
  marginBottom: { xs: '12px', sm: '16px' }
};

export const warningIconSx: SxProps<Theme> = {
  width: '20px',
  height: '20px',
  flexShrink: 0
};

export const warningTextSx: SxProps<Theme> = {
  fontFamily: 'Inter',
  fontWeight: 500,
  fontSize: { xs: '12px', sm: '14px' },
  lineHeight: { xs: '16px', sm: '20px' },
  color: 'var(--color-primary)',
  flex: 1,
  wordBreak: 'break-word'
};

export const recommendedChipSx: SxProps<Theme> = {
  position: 'absolute',
  top: '0',
  left: '0',
  paddingY: '4px',
  paddingX: '16px',
  backgroundColor: 'var(--color-bg-success-light)',
  borderBottomRightRadius: '12px'
};

export const recommendedChipTextSx: SxProps<Theme> = {
  fontFamily: 'Inter',
  fontWeight: 500,
  fontSize: '12px',
  lineHeight: 'var(--line-height-14)',
  color: 'var(--color-success-deep)'
};

// Notes Component Styles
export const notesContainerSx: SxProps<Theme> = {
  paddingX: { xs: '16px', sm: '24px' }
};

export const notesTitleSx: SxProps<Theme> = {
  fontFamily: 'Inter',
  fontWeight: 500,
  fontSize: 'var(--font-size-14)',
  lineHeight: 'var(--line-height-20)',
  color: 'var(--color-primary)'
};

export const notesListContainerSx: SxProps<Theme> = {
  marginTop: '16px'
};

export const notesItemContainerSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px'
};

export const notesItemTextSx: SxProps<Theme> = {
  fontFamily: 'Inter',
  fontWeight: 500,
  fontSize: 'var(--font-size-14)',
  lineHeight: 'var(--line-height-20)',
  color: 'var(--color-text-muted)'
};

export const notesDividerSx: SxProps<Theme> = {
  marginTop: '16px',
  marginBottom: '16px'
};

// ConfirmAndPay Component Styles
export const confirmAndPayTitleContainerSx: SxProps<Theme> = {
  marginY: '24px'
};

export const confirmAndPayTitleSx: SxProps<Theme> = {
  fontFamily: 'Inter',
  fontWeight: 700,
  fontSize: 'var(--font-size-30)',
  lineHeight: 'var(--line-height-38)',
  color: 'var(--color-primary)'
};

export const confirmAndPayStickyContainerSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  height: 'max-content'
};

// Email Alerts Accordion Styles
export const emailAlertsAccordionContainerSx: SxProps<Theme> = {
  width: '100%',
  backgroundColor: 'var(--color-white)',
  borderRadius: { xs: '8px', sm: '12px' },
  boxShadow: '0px 1px 8px 0px var(--color-shadow-card)',
  padding: { xs: '16px', sm: '24px' },
  paddingY: { xs: '16px', sm: '24px' }
};

export const emailAlertsHeaderSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  cursor: 'pointer',
  marginBottom: '16px'
};

export const emailAlertsTitleSx: SxProps<Theme> = {
  fontFamily: 'Inter',
  fontWeight: 600,
  fontSize: { xs: '20px', sm: '24px' },
  lineHeight: { xs: '28px', sm: '32px' },
  color: 'var(--color-primary)'
};

export const emailAlertsChevronSx: SxProps<Theme> = {
  color: 'var(--color-primary)',
  fontSize: { xs: '20px', sm: '24px' },
  transition: 'transform 0.3s ease'
};

export const emailAlertsLabelSx: SxProps<Theme> = {
  fontFamily: 'Inter',
  fontWeight: 400,
  fontSize: { xs: '13px', sm: '14px' },
  lineHeight: { xs: '18px', sm: '20px' },
  color: 'var(--color-text-purple)',
  marginBottom: '8px'
};

export const emailAlertsInputSx: SxProps<Theme> = {
  width: '100%',
  fontFamily: 'Inter',
  fontSize: { xs: '13px', sm: '14px' },
  lineHeight: { xs: '18px', sm: '20px' },
  color: 'var(--color-primary)',
  backgroundColor: 'var(--color-white)',
  border: '1px solid #E5E5E5',
  borderRadius: '6px',
  padding: '12px',
  minHeight: '120px',
  resize: 'vertical',
  outline: 'none',
  '&:hover': {
    borderColor: '#E5E5E5'
  },
  '&:focus': {
    borderColor: 'var(--color-primary)',
    borderWidth: '1px'
  },
  '&::placeholder': {
    color: '#9CA3AF',
    opacity: 1
  }
};

export const emailAlertsCharCounterSx: SxProps<Theme> = {
  fontFamily: 'Inter',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: 'var(--line-height-16)',
  color: '#9CA3AF',
  textAlign: 'right',
  marginTop: '4px'
};

// Campaign Notes Styles
export const campaignNotesExampleContainerSx: SxProps<Theme> = {
  marginTop: '24px'
};

const campaignNotesExampleTextBaseSx: SxProps<Theme> = {
  fontFamily: 'Inter',
  fontWeight: 400,
  fontSize: 'var(--font-size-14)',
  lineHeight: 'var(--line-height-20)',
  color: 'var(--color-text-secondary)'
};

export const campaignNotesExampleTextFirstSx: SxProps<Theme> = {
  ...campaignNotesExampleTextBaseSx,
  marginBottom: '12px'
};

export const campaignNotesExampleTextSecondSx: SxProps<Theme> = {
  ...campaignNotesExampleTextBaseSx,
  marginTop: '12px'
};

// Business Details Form Styles
export const businessDetailsDescriptionSx: SxProps<Theme> = {
  fontFamily: 'Inter',
  fontWeight: 400,
  fontSize: { xs: '13px', sm: '14px' },
  lineHeight: { xs: '18px', sm: '20px' },
  color: 'var(--color-text-purple)',
  marginBottom: { xs: '20px', sm: '24px' }
};

export const businessDetailsSectionContainerSx: SxProps<Theme> = {
  marginBottom: { xs: '24px', sm: '32px' }
};

export const businessDetailsSectionTitleSx: SxProps<Theme> = {
  fontFamily: 'Inter',
  fontWeight: 500,
  fontSize: { xs: '14px', sm: '16px' },
  lineHeight: { xs: '20px', sm: '24px' },
  color: 'var(--color-primary)',
  marginBottom: { xs: '10px', sm: '12px' }
};

export const businessDetailsSectionSubtitleSx: SxProps<Theme> = {
  fontFamily: 'Inter',
  fontWeight: 400,
  fontSize: { xs: '13px', sm: '14px' },
  lineHeight: { xs: '18px', sm: '20px' },
  color: 'var(--color-text-purple)',
  marginBottom: { xs: '12px', sm: '16px' }
};

export const businessDetailsLinkTextSx: SxProps<Theme> = {
  fontFamily: 'Inter',
  fontWeight: 400,
  fontSize: { xs: '13px', sm: '14px' },
  lineHeight: { xs: '18px', sm: '20px' },
  color: 'var(--color-text-purple)',
  marginTop: { xs: '12px', sm: '16px' }
};

export const businessDetailsLinkSx: SxProps<Theme> = {
  color: 'var(--color-purple-strong)',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline'
  }
};

// Business Images Styles
export const businessImagesTitleSx: SxProps<Theme> = {
  fontFamily: 'Inter',
  fontWeight: 500,
  fontSize: 'var(--font-size-14)',
  color: 'var(--color-text-secondary)',
  marginBottom: '12px'
};

export const businessImagesCardSx: SxProps<Theme> = {
  backgroundColor: 'var(--color-white)',
  border: '1px solid',
  borderColor: 'var(--color-border)',
  borderRadius: '6px',
  padding: '20px'
};

export const businessImagesPlaceholderSx: SxProps<Theme> = {
  backgroundColor: 'var(--color-bg-muted)',
  border: '1px dashed',
  borderColor: 'var(--color-text-placeholder)',
  borderRadius: '6px',
  width: '100%',
  aspectRatio: '1 / 1',
  cursor: 'pointer'
};

export const businessImagesImageSx: SxProps<Theme> = {
  width: '100%',
  aspectRatio: '1 / 1',
  borderRadius: '6px',
  objectFit: 'contain',
  cursor: 'pointer'
};

// Terms & Conditions Styles
export const termsHeadingSx: SxProps<Theme> = {
  fontFamily: 'Inter',
  fontWeight: 600,
  fontSize: { xs: '20px', sm: '24px' },
  lineHeight: { xs: '28px', sm: '32px' },
  color: 'var(--color-primary)',
  marginX: '24px'
};

export const termsContainerSx: SxProps<Theme> = {
  marginX: '24px',
  marginTop: '24px'
};

export const termsDescriptionSx: SxProps<Theme> = {
  fontFamily: 'Inter',
  fontWeight: 500,
  fontSize: 'var(--font-size-16)',
  color: 'var(--color-primary)',
  marginBottom: '8px'
};

export const termsListSx: SxProps<Theme> = {
  pl: 3,
  mt: 1,
  listStyleType: 'disc',
  color: 'var(--color-text-secondary)'
};

export const termsListItemSx: SxProps<Theme> = {
  display: 'list-item',
  p: 0,
  lineHeight: 'var(--line-height-24)',
  fontFamily: 'Inter',
  fontWeight: 400,
  fontSize: 'var(--font-size-14)',
};

export const termsCheckboxLabelSx: SxProps<Theme> = {
  marginTop: '16px',
  fontFamily: 'Inter',
  fontWeight: 400,
  fontSize: 'var(--font-size-14)',
  lineHeight: 'var(--line-height-20)',
  color: 'var(--color-primary)'
};

